import Image from 'next/image';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import KetoContainer from './keto-container';
import styles from './keto-intro.module.css';
import KetoTypography, { KetoTypographyVariant } from './keto-typography';

export default function KetoIntro() {
  return (
    <section className={styles.intro}>
      <KetoContainer>
        <AnimationOnScroll
          animateOnce
          duration={2}
          animateIn="animate__fadeIn"
          className={styles.intro_inner}
        >
          <div className={styles.intro_start}>
            <KetoTypography
              variant={KetoTypographyVariant.HEADLINE_1}
              tag="h1"
              className={styles.intro_title}
            >
              What is Keto Kitchen?
            </KetoTypography>
            <KetoTypography
              variant={KetoTypographyVariant.BODY_2}
              tag="p"
              className={styles.intro_text}
            >
              Do you or your family members need to follow a Low Carb Diet? How
              often does it come to your mind that you are deprived of delicious
              food? How difficult is it sometimes to tell your baby that these
              mouth-watering sweets or yummi pastries are prohibited?
            </KetoTypography>
            <KetoTypography
              variant={KetoTypographyVariant.BODY_2}
              tag="p"
              className={styles.intro_text}
            >
              Our Keto Kitchen team gives you a healthy and tasty alternatives
              to diversify your daily menu and make your new healthy lifestyle
              enjoyable for long time!
            </KetoTypography>
            <span className={styles.soon}>Coming Soon</span>
            <div className={styles.buttons}>
              <a className={styles.intro_button} href="#">
                <img src="/keto/icons/apple-store.svg" alt="heart" />
              </a>

              <a
                className={styles.intro_button}
                target="_blank"
                rel="noreferrer"
                href="https://www.youtube.com/@keto_kitchen"
              >
                <img src="/keto/icons/youtube.svg" alt="youtube" />
              </a>
            </div>
          </div>
          <div className={styles.intro_end}>
            <Image
              alt="keto kitchen icons"
              width={771}
              height={565}
              src="/keto/icons/Group.png"
            />
            <div className={styles.intro_wrapper}>
              <Image
                alt="keto kitchen app preview"
                width={378}
                height={565}
                className={styles.intro_image}
                src="/keto/intro/intro-img.png"
              />
            </div>
          </div>
          <img
            className={styles.intro_heart}
            src="/keto/icons/heart-intro.svg"
            alt="heart icon"
          />
        </AnimationOnScroll>
      </KetoContainer>
    </section>
  );
}
